import './config.scss';

import './config-step-1/config-step-1.scss';
import './config-step-2/config-step-2.scss';
import './config-step-3/config-step-3.scss';
import './config-step-4/config-step-4.scss';
import './config-step-5/config-step-5.scss';

import './config-step-1/config-step-1.js';
import './config-step-2/config-step-2.js';
import './config-step-3/config-step-3.js';
import './config-step-4/config-step-4.js';
import './config-step-5/config-step-5.js';

import modal from 'components/modal/modal';

import gustibusConfigData from './config-data.js';



const config = () => {

    const productTabs = document.querySelectorAll('.product-page-section .tabs [data-tab-target]')
    const productTabContents = document.querySelectorAll('.product-page-section .tab-content [data-tab-content]')
    const nextBtns = document.querySelectorAll('.config-wrapper .next-btn');
    const prevBtns = document.querySelectorAll('.config-wrapper .prev-btn');

    productTabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = document.querySelector(tab.dataset.tabTarget)

            productTabContents.forEach(tabContent => {
                tabContent.classList.remove('active')
            })
            productTabs.forEach(tab => {
                tab.classList.remove('active')
            })
            tab.classList.add('active')
            target.classList.add('active')
        })
    })

    function handleTabNavigation(direction) {
        const currentTab = document.querySelector('.tabs .active');
        let targetTab;

        if (direction === 'next') {
            targetTab = currentTab.nextElementSibling;
        } else if (direction === 'prev') {
            let prevEl = currentTab.previousElementSibling;
            if(document.querySelector(prevEl.getAttribute('data-tab-target')).classList.contains('disabled')) {
                targetTab = prevEl.previousElementSibling;
            } else {
                targetTab = currentTab.previousElementSibling;
            }
        }

        if (targetTab) {
            const configPageSection = document.querySelector('.config-page-section');
            configPageSection.scrollIntoView({ behavior: 'smooth' })
            currentTab.classList.remove('active');
            targetTab.classList.add('active');

            if (direction === 'next') {
                currentTab.classList.add('filled');
            } else if (direction === 'prev') {
                targetTab.classList.remove('filled');
            }

            const currentTabContent = document.querySelector(currentTab.dataset.tabTarget);
            const targetTabContent = document.querySelector(targetTab.dataset.tabTarget);

            currentTabContent.classList.remove('active');
            targetTabContent.classList.add('active');
        }
    }

    nextBtns.forEach(nextBtn => {
        nextBtn.addEventListener('click', function() {
            if(!this.classList.contains('disabled')) {
                handleTabNavigation('next');
            }
        });
    });

    prevBtns.forEach(prevBtn => {
        prevBtn.addEventListener('click', () => {
            handleTabNavigation('prev');
        });
    });

    modal();

    var wpcf7Elm = document.querySelector( '.wpcf7' );

    wpcf7Elm.addEventListener( 'wpcf7mailsent', function( event ) {
        var inputs = event.detail.inputs;

        sendInfoTagManager(inputs);

        const modalTarget = document.querySelector('.cf7-modal');
        modalTarget.classList.add('open');
        document.body.style.overflow = 'hidden';
    }, false );

    function sendInfoTagManager(inputs) {
        const selected = window.mergedData;
        let data = {};

        inputs.forEach((el) => {
            data[el.name] = el.value;
        })

        data.event = 'configurator_submission';
        data.formLocation = 'configurator_page';
        data.lang = document.querySelector('html').getAttribute('lang');

        data.selected_product = gustibusConfigData.categories[selected.selectedCategory].name;
        data.selected_category = selected.selectedSubcategory ? gustibusConfigData.categories[selected.selectedCategory].subcategories[selected.selectedSubcategory].name : 'N/A';
        data.selected_typology = selected.selectedGroup ? gustibusConfigData.categories[selected.selectedCategory].subcategories[selected.selectedSubcategory].groups[selected.selectedGroup].name : 'N/A';
        data.selected_recipe = getRecipeName();
        data.selected_ingredients = getIngridientsNames();
        data.selected_format = getFormatName();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);

    }

    function getFormatName() {
        if(!document.querySelector('#selected_format').value.length > 0) {
            return 'N/A';
        }

        const activeFormat = document.querySelector('.format-elements .format-element.active');
        return activeFormat.querySelector('.format-name').textContent;

    }

    function getIngridientsNames() {
        if(!document.querySelector('#selected_ingredients').value.length > 0) {
            return 'N/A';
        }

        const activeIngredients = document.querySelectorAll('.ingredients-elements .ingredients-element.active');
        let names = [];
        activeIngredients.forEach((el) => {
            names.push(el.querySelector('.ingredients-name').textContent);
        });

        return names.join(', ');

    }

    function getRecipeName() {
        if(!document.querySelector('#selected_recipe').value.length > 0) {
            return 'N/A';
        }

        const activeRecipe = document.querySelector('.recipe-elements .recipe-element.active');
        return activeRecipe.querySelector('.recipe-name').textContent;

    }

}

export default config;